import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Registration from './pages/Registration';
import Hospitals from './pages/Hospitals';
import Doctors from './pages/Doctors';
import Patients from './pages/Patients';
import Pharmacies from './pages/Pharmacies';
import Labs from './pages/Labs';
import Prescriptions from './pages/Prescriptions';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Alerts from './pages/Alerts';
import Drugs from './pages/Drugs';
import MedicalBooks from './pages/MedicalBooks';
import LogsAction from './pages/LogsAction';
import Layout from './components/Layout';

const PrivateRoute = ({ children, allowedRoles }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) {
        return <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b'}}>Загрузка системы...</div>;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        if (user.role === 'chief_doctor') {
            return <Navigate to="/hospitals" replace />;
        }
        return <Navigate to="/" replace />;
    }

    return <Layout>{children}</Layout>;
};

const PublicRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) return null;

    if (user) {
        if (user.role === 'chief_doctor') return <Navigate to="/hospitals" replace />;
        return <Navigate to="/" replace />;
    }

    return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={ <PublicRoute><Login /></PublicRoute> } />

          <Route path="/" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Dashboard /></PrivateRoute>} />
          <Route path="/pharmacies" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Pharmacies /></PrivateRoute>} />
          <Route path="/labs" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Labs /></PrivateRoute>} />
          <Route path="/prescriptions" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Prescriptions /></PrivateRoute>} />
          <Route path="/drugs" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Drugs /></PrivateRoute>} />
          <Route path="/medical-books" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><MedicalBooks /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Analytics /></PrivateRoute>} />
          <Route path="/alerts" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry']}><Alerts /></PrivateRoute>} />

          <Route path="/hospitals" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'ministry', 'chief_doctor']}><Hospitals /></PrivateRoute>} />
          <Route path="/doctors" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'ministry', 'chief_doctor']}><Doctors /></PrivateRoute>} />
          <Route path="/patients" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'ministry', 'chief_doctor']}><Patients /></PrivateRoute>} />

          <Route path="/logs" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'moderator', 'ministry', 'chief_doctor']}><LogsAction /></PrivateRoute>} />

          <Route path="/registration" element={<PrivateRoute allowedRoles={['super_admin', 'admin', 'ministry', 'chief_doctor']}><Registration /></PrivateRoute>} />

          <Route path="/settings" element={<PrivateRoute allowedRoles={['super_admin', 'admin']}><Settings /></PrivateRoute>} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;